export default defineNuxtPlugin({
  name: 'funnel-context',
  enforce: 'pre',
  setup() {
    useFunnelContext();
  },
});
